import * as api from './sap-odata.api';
import * as queries from './sap-odata.queries';
import * as types from './sap-odata.types';

export * from './sap-odata.api';
export * from './sap-odata.queries';
export * from './sap-odata.types';

export default { ...api, ...queries, types };
